window.$ = window.jQuery = require('jquery')
import isMobileChk from './is_mobile_chk.js'

export default function menuDropdown() {
  $(() => {
    const $trigger = $('.menu-item-has-children')
    if (isMobileChk() === false) {
      $trigger.on({
        'mouseenter': function () {
          $(this).find('ul').show()
          $(this).find('ul').css({
            'display': 'block'
          })
          $(this).find('ul').on({
            'mouseenter': function () {
              $(this).show()
            },
            'mouseleave': function () {
              $(this).hide()
            }
          })
        },
        'mouseleave': function () {
          $(this).find('ul').hide()
        }
      })
    }
  })
}
